import type { FC, SVGProps } from "react";

/** `icon-park-outline:left-bar` — collapses the rail, and closes the mobile drawer (Figma 1052:47942). */
export const LeftBarIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(2.25 2.25)">
      <path
        d="M17.25 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V17.25C0.75 18.0784 1.42157 18.75 2.25 18.75H17.25C18.0784 18.75 18.75 18.0784 18.75 17.25V2.25C18.75 1.42157 18.0784 0.75 17.25 0.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 0.75V18.75M4.25 18.75H7.25M4.25 0.75H7.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98123 9.2309C9.67292 9.52379 9.67292 9.99867 9.98123 10.2916L13.4023 13.5416C13.7106 13.8345 14.2105 13.8345 14.5188 13.5416C14.8271 13.2487 14.8271 12.7738 14.5188 12.4809L11.656 9.76123L14.5188 7.04156C14.8271 6.74867 14.8271 6.27379 14.5188 5.9809C14.2105 5.68801 13.7106 5.68801 13.4023 5.9809L9.98123 9.2309Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
